import script from "./AvisoDeConteudoAdulto.vue?vue&type=script&setup=true&lang=js"
export * from "./AvisoDeConteudoAdulto.vue?vue&type=script&setup=true&lang=js"

import "./AvisoDeConteudoAdulto.vue?vue&type=style&index=0&id=46ca0462&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ca0462"]])

export default __exports__